import React from "react";
import { View, StyleSheet } from "react-native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { QuestionsStackParamList } from "@navigation/types";
import { Colors } from "@config/colors";
import SideMenu from "@components/UI/SideMenu/SideMenu";
import { UI } from "@config/constants";
import QuestionsList from "@components/Questions/Index/QuestionsList";
import TitleCard from "@components/UI/TitleCard";
import NewFormLink from "@components/UI/BaseCard/NewFormLink";

type Props = NativeStackScreenProps<QuestionsStackParamList, "QuestionsIndex">;

const IndexQuestionsScreen: React.FC<Props> = ({ navigation }) => {
  return (
    <View style={styles.screen}>
      <View style={styles.content}>
        <View style={styles.GLDR1}>
          <SideMenu />
        </View>
        <View style={styles.GLDR2}>
          <TitleCard
            title="Intrebari"
            backgroundColor={Colors.backgroundSecondary}
            rightItem={
              <NewFormLink
                onPress={() => navigation.push("QuestionsNew")}
                text="Adauga o intrebare"
              />
            }
          >
            <QuestionsList />
          </TitleCard>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: Colors.backgroundPrimary,
  },
  content: {
    margin: UI.sizes.margin / 2,
    flex: 1,
    flexDirection: "row",
  },
  GLDR1: { flex: 1 },
  GLDR2: { flex: 1.618 + 2.618, margin: UI.sizes.margin / 2 },
});

export default IndexQuestionsScreen;
